"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Game = void 0;
var AudioManager_1 = require("./AudioManager");
var Game = /** @class */ (function (_super) {
    __extends(Game, _super);
    function Game(config) {
        var _this = _super.call(this, config) || this;
        Game.currentInstance = _this;
        return _this;
    }
    Game.prototype.onBlur = function () {
        AudioManager_1.AudioManager.mute();
        _super.prototype.onBlur.call(this);
    };
    Game.prototype.onFocus = function () {
        AudioManager_1.AudioManager.unmute();
        _super.prototype.onFocus.call(this);
    };
    return Game;
}(Phaser.Game));
exports.Game = Game;
